var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAssets = function SvgAssets(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.033,
    height: 24.153,
    viewBox: "0 0 25.033 24.153",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#1a295b;stroke-width:.3px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.87 -4.148)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.039,
    height: 2.039,
    className: "a",
    transform: "translate(5.072 18.011)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.039,
    height: 2.039,
    className: "a",
    transform: "translate(8.678 18.011)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.039,
    height: 2.039,
    className: "a",
    transform: "translate(5.072 21.688)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.039,
    height: 2.039,
    className: "a",
    transform: "translate(8.678 21.688)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.039,
    height: 2.039,
    className: "a",
    transform: "translate(20.786 21.688)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.039,
    height: 2.039,
    className: "a",
    transform: "translate(20.786 18.011)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.039,
    height: 2.039,
    className: "a",
    transform: "translate(9.668 10.853)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.039,
    height: 2.039,
    className: "a",
    transform: "translate(13.272 10.853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.243,13.586V12.112h0V4.366L6.721,8.741v4.846H2.02V28.151H26.753V13.586Zm-5.859,13.18H3.406V14.972h8.978Zm4.47-14.654h-.035V26.766H13.308V14.048h-5.2V9.7l8.748-3.322Zm8.513,14.654H18.243V14.972h7.124Z",
    className: "a",
    transform: "translate(0)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAssets);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS4wMzMiIGhlaWdodD0iMjQuMTUzIiB2aWV3Qm94PSIwIDAgMjUuMDMzIDI0LjE1MyI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ZmZjtzdHJva2U6IzFhMjk1YjtzdHJva2Utd2lkdGg6LjNweH08L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS44NyAtNC4xNDgpIj48cmVjdCB3aWR0aD0iMi4wMzkiIGhlaWdodD0iMi4wMzkiIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1LjA3MiAxOC4wMTEpIi8+PHJlY3Qgd2lkdGg9IjIuMDM5IiBoZWlnaHQ9IjIuMDM5IiBjbGFzcz0iYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC42NzggMTguMDExKSIvPjxyZWN0IHdpZHRoPSIyLjAzOSIgaGVpZ2h0PSIyLjAzOSIgY2xhc3M9ImEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuMDcyIDIxLjY4OCkiLz48cmVjdCB3aWR0aD0iMi4wMzkiIGhlaWdodD0iMi4wMzkiIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4LjY3OCAyMS42ODgpIi8+PHJlY3Qgd2lkdGg9IjIuMDM5IiBoZWlnaHQ9IjIuMDM5IiBjbGFzcz0iYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAuNzg2IDIxLjY4OCkiLz48cmVjdCB3aWR0aD0iMi4wMzkiIGhlaWdodD0iMi4wMzkiIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMC43ODYgMTguMDExKSIvPjxyZWN0IHdpZHRoPSIyLjAzOSIgaGVpZ2h0PSIyLjAzOSIgY2xhc3M9ImEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuNjY4IDEwLjg1MykiLz48cmVjdCB3aWR0aD0iMi4wMzkiIGhlaWdodD0iMi4wMzkiIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy4yNzIgMTAuODUzKSIvPjxwYXRoIGQ9Ik0xOC4yNDMsMTMuNTg2VjEyLjExMmgwVjQuMzY2TDYuNzIxLDguNzQxdjQuODQ2SDIuMDJWMjguMTUxSDI2Ljc1M1YxMy41ODZabS01Ljg1OSwxMy4xOEgzLjQwNlYxNC45NzJoOC45NzhabTQuNDctMTQuNjU0aC0uMDM1VjI2Ljc2NkgxMy4zMDhWMTQuMDQ4aC01LjJWOS43bDguNzQ4LTMuMzIyWm04LjUxMywxNC42NTRIMTguMjQzVjE0Ljk3Mmg3LjEyNFoiIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSIvPjwvZz48L3N2Zz4=";